import { Users, UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { MATE_CONFIG } from "@/config/mateConfig";

interface EmptyStateProps {
  onInviteClick: () => void;
}

export function EmptyState({ onInviteClick }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="mb-6">
        <div className="bg-gray-100 rounded-full p-4 inline-block">
          <Users className="h-12 w-12 text-gray-400" />
        </div>
      </div>

      <h3 className="text-xl font-medium text-tx-dark mb-2">No mates yet</h3>

      <p className="text-tx-muted mb-8 max-w-md leading-relaxed">
        Invite {MATE_CONFIG.MAX_MATES_TEXT} to share workouts and keep each
        other motivated.
      </p>

      <Button onClick={onInviteClick} className="flex items-center gap-2">
        <UserPlus className="h-4 w-4" />
        Invite by Email
      </Button>
    </div>
  );
}
